import { arrayToDistinct } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { AutoComplete, Form } from "antd";
import React, { useMemo } from "react";
import FormItemProps from "../../../types/FormItemProps";

export default (props: FormItemProps) => {
  const t = useTranslation();

  const options = useMemo(() => {
    if (!props.items) return [];
    const storage = props.items
      .filter((item) => item.storageLocation)
      .map((item) => ({ value: item.storageLocation }));

    return arrayToDistinct(storage, (obj) => obj.value);
  }, [props.items]);

  return (
    <Form.Item
      label={t("maintenance:items.create.form.storageLocation.label")}
      name="storageLocation"
      initialValue={props.editItem?.storageLocation}
    >
      <AutoComplete options={options} filterOption />
    </Form.Item>
  );
};
